import { FC, Fragment } from "react";
import { Box, IconButton, Switch, Typography } from "@mui/material";
import { CommonStyle, Loader } from "Components";
import {
  CPProblemBoxProps,
  PrblmActivePlan,
  PrblmActivePlanICD10Code
} from "DataTypes/PatientManagement.type";
import NoData from "Components/NoData";
import ImgPath from "Constant/Imgs";
import UncontrolledAccord from "Components/Accordion1/Uncontrolled";

const ProblemBox: FC<CPProblemBoxProps> = (props) => {
  const {
    loadingProblem,
    handleSelectProb,
    newPrblmList,
    handleTogglePAP,
    readOnly,
    isRecurring,
    isRPM
  } = props;

  const HeadUI: (data: PrblmActivePlan) => JSX.Element = (data) => {
    return (
      <Box key={data.id} sx={{
        ...CommonStyle.sxRow,
        justifyContent: "space-between",
        width: "100%"
      }}>
        <Typography variant="subtitle1">
          {data.problemName}
        </Typography>
        {data.activePlanId && !isRecurring && !isRPM && (
          <Box display="flex" alignItems="center">
            <IconButton
              sx={{ ...CommonStyle.sxRoundIconsMainSm, ml: 0.5 }}
              onClick={() => handleSelectProb(data)}
              title="View Pre-Approved Plan"
            >
              <ImgPath.PreApprovedIcon />
            </IconButton>
            <Switch
              color="secondary"
              checked={data.isPlanInUse}
              title={"Use this Pre-Approved Plan"}
              size="small"
              onClick={() => handleTogglePAP(data)}
              disabled={readOnly}
            />
          </Box>
        )}
      </Box>
    )
  }

  const ICD10CodeUI: (
    icd10List: PrblmActivePlanICD10Code[]
  ) => JSX.Element = (icd10List) => {
    return (
      <Fragment>
        {icd10List.map((el) => {
          return (
            <Typography
              sx={{ ...sxList }}
              key={el.id}
              variant="subtitle2"
            >{`${el.idc10Code + " -"} ${el.idc10Codedescription}`}</Typography>
          );
        })}
      </Fragment>
    )
  };

  return (
    <Box height="47%" sx={{ ...CommonStyle.sxWhiteBox, mr: 2 }}>
      <Typography
        variant="subtitle1"
        sx={{ ...CommonStyle.sxRow, ...sxCategoryHead }}
      >
        {"Problem(s)"}
      </Typography>
      <Box height="80%" overflow="auto" sx={{ px: 2 }}>
        {loadingProblem ? (
          <Loader />
        ) : newPrblmList.length < 1 ? (
          <NoData />
        ) : (
          <Fragment>
            {[...newPrblmList].map((el) => {
              return (
                <UncontrolledAccord
                  key={el.id}
                  head={HeadUI(el)}
                  body={ICD10CodeUI(el.icd10CodeList)}
                  expandOnIconOnly
                />
              );
            })}
          </Fragment>
        )}
      </Box>
    </Box>
  );
};
export default ProblemBox;

const sxCategoryHead = {
  height: "20%",
  fontWeight: "bold",
  px: 2,
};
const sxList = {
  pt: 1.5,
  pb: 1,
  mr: 1,
  borderBottom: "1px solid",
  borderBottomColor: "custom.main",
};
